<template>
    <div>
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title>{{$t(createFormName)}}</v-toolbar-title>
            </v-toolbar>
            <v-form id="createForm" @keyup.enter.native="onSave">
                <v-layout wrap>
                    <v-flex xs12 v-for="item in inputItems" style="padding: 10px">
                        <i-tree-picker v-if="item.type=='tree'" v-bind="item" :label="$t(item.label)"
                                       :placeholder="$t(item.placeholder)" v-model="values[item.name]"
                                       :text-value="values[item.textValue]"></i-tree-picker>
                        <v-select v-else-if="item.type=='select'"
                                  :label="$t(item.label)"
                                  v-model.trim="values[item.name]"
                                  v-validate="item.validate"
                                  :items="item.items"
                                  :item-text="item.itemText"
                                  :item-value="item.itemValue"
                                  ref="input"
                        ></v-select>
                        <div v-else-if="item.type=='ckeditor'">
                            {{$t(item.label)}}
                            <ckeditor
                                    v-model="values[item.name]"
                                    :config="editorConfig"
                            ></ckeditor>
                        </div>

                        <i-date-picker
                                v-else-if="item.type=='datepicker'"
                                :label="$t(item.label)"
                                formatter="DD/MM/YYYY"
                                v-model="values[item.name]"
                                :v-validate="item.validate"
                                ref="input">

                        </i-date-picker>
                        <v-textarea
                                v-else-if="item.type=='textarea'"
                                :label="$t(item.label)"
                                :key="item.name"
                                v-model.trim="values[item.name]"
                                :v-validate="item.validate"
                                ref="input"></v-textarea>
                        <i-upload v-else-if="item.type=='Upload'"
                                  :id="item.name"
                                  :name="item.name"
                                  :label="$t(item.label)"
                                  v-model="values[item.name]"
                                  :v-validate="item.validate"
                                  ref="input"/>
                        <v-text-field
                                v-else :type="item.type"
                                :prepend-icon="item.icon"
                                :v-validate="item.validate"
                                :label="$t(item.label)"
                                :data-vv-as="$t(item.label)"
                                :id="item.id"
                                v-model="values[item.name]"
                                :max-length="item.maxlength"
                                ref="input"></v-text-field>
                    </v-flex>
                </v-layout>
            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{$t('lang.common.save')}}
                </v-btn>
                <v-btn color="danger" v-if="enableDelete==true" @click="onDelete">
                    <v-icon dark left>delete</v-icon>
                    {{$t('lang.common.delete')}}
                </v-btn>
                <v-btn @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{$t('lang.common.cancel')}}
                </v-btn>
            </div>
        </v-card>
    </div>
</template>

<script>
    import CTextbox from "./Textbox";
    import IDatePicker from "./DatePicker";
    import Validator from "../../../public/js/validator";
    import axios from "axios";
    import ITreePicker from "./TreePicker";
    import {message} from "@/shared/message";
    import IUpload from "./Upload";

    const v = Validator();
    //console.log("---v---");
    //console.log(v);

    export default {
        name: 'c-create-form',
        components: {IUpload, ITreePicker, CTextbox, IDatePicker, Validator},
        inheritAttrs: true,
        props: {
            enableDelete: {
                type: Boolean,
                default: false
            },
            createFormName: {
                type: String,
                default: 'Create Form'
            },
            inputItems: {
                type: Array,
                default: () => []
            },
            searchDiv: {
                type: String,
                default: 'searchDiv'
            },
            createDiv: {
                type: String,
                default: 'createDiv'
            },
            createUrl: {
                type: String,
                default: ""
            },
            deleteUrl: {
                type: String,
                default: ""
            },
            column: {
                type: String,
                default: "12"
            },
            defaultData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data: () => {
            return {
                values: {},
                model: {},
                editorConfig: {
                    toolbarGroups : [
                        { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                        { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                        { name: 'forms', groups: [ 'forms' ] },
                        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                        { name: 'links', groups: [ 'links' ] },
                        { name: 'insert', groups: [ 'insert' ] },
                        { name: 'styles', groups: [ 'styles' ] },
                        { name: 'colors', groups: [ 'colors' ] },
                        { name: 'tools', groups: [ 'tools' ] },
                        { name: 'others', groups: [ 'others' ] },
                        { name: 'about', groups: [ 'about' ] }
                    ],
                    removeButtons: 'NewPage,Print,Save,Templates,Replace,Find,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,Anchor,Flash,Smiley,PageBreak,ShowBlocks,About,Language,Iframe,Image'
                },
            }
        },
        watch: {
            defaultData: function (value) {
                this.values = this.copyValue(value);
            }
        },
        methods: {
            copyValue: function (value) {
                let ob = {};
                for (let key in value) {
                    ob[key] = value[key];
                }
                return ob;
            },
            onSave: function () {
                let validate = v.validate(this);
                if (validate) {
                    axios.post(process.env.VUE_APP_API_URL + this.createUrl, this.values).then(data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.save_success"));
                            this.$emit("save", this.values);
                            this.onCancel();
                        } else {
                            message.error(data.description);
                        }
                    }, error => {
                        message.error(error);
                    });

                } else {
                    message.error(this.$t("lang.common.validate_fail"));
                }
            },

            onView: function (value) {
                this.values = value;
            },

            onDelete: function () {
                if (confirm(this.$t("lang.common.deleteConfirm"))) {
                    axios.post(process.env.VUE_APP_API_URL + this.deleteUrl, this.values).then(data => {
                        message.success(this.$t("lang.common.delete_success"));
                        this.$emit("cancel");
                    }, error => {
                        message.error(this.$t("lang.common.deleteError"));
                    });
                }
                ;
            },

            onCancel: function () {
                try {
                    if (document.getElementById(this.searchDiv) != null)
                        document.getElementById(this.searchDiv).style.display = "";
                    if (document.getElementById(this.createDiv) != null)
                        document.getElementById(this.createDiv).style.display = "none";
                    ////console.log(this.$parent);
                    this.$parent.onSearch();
                } catch (e) {
                    //console.log(e);
                }
                this.$emit("cancel");
            }
        },

        created() {
            this.values = this.copyValue(this.defaultData);
        }
    }
</script>
